//dev server API

export const BASE_URL = 'https://ap.markdowntoday.com/api';
export const IMG_BASE_URL = 'https://ap.markdowntoday.com/assets/images';

//local server API

// export const BASE_URL = 'http://127.0.0.1:8000/api';
// export const IMG_BASE_URL = 'http://127.0.0.1:8000/assets/images';